import { license, LICENSE_TYPE_JWT } from '../constants';
import licenseService from '../services/license';

// fetch license request list
const fetchLicenseRequest = () => ({
  type: license.FETCH_LICENSE_REQUEST
});

const fetchLicenseSuccess = licenses => ({
  type: license.FETCH_LICENSE_SUCCESS,
  licenses
});

const fetchLicenseFailure = error => ({
  type: license.FETCH_LICENSE_FAILED,
  error
});

export const fetchLicenseStatusReset = () => ({
  type: license.FETCH_LICENSE_STATUS_RESET
});

export const fetchLicense = (page = 1, pageSize = 20, sort, filter) => async (
  dispatch,
  getState
) => {
  dispatch(fetchLicenseRequest());

  const token = getState().user.accessToken;

  let res;

  try {
    res = await licenseService.getLicenses(token, page, pageSize, sort, filter);

    if (typeof res === 'object') {
      if (res.status === 200) {
        dispatch(
          fetchLicenseSuccess({
            requests: res.data.Result.requests,
            total: res.data.Result.total,
            page,
            pageSize,
            sort,
            filter
          })
        );
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          fetchLicenseFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(fetchLicenseFailure(e));
  }

  return res;
};

// create license
const createLicenseRequest = () => ({
  type: license.CREATE_LICENSE_REQUEST
});

const createLicenseSuccess = licenses => ({
  type: license.CREATE_LICENSE_SUCCESS,
  licenses
});

const createLicenseFailure = error => ({
  type: license.CREATE_LICENSE_FAILED,
  error
});

export const createLicenseStatusReset = () => ({
  type: license.CREATE_LICENSE_STATUS_RESET
});

export const createLicense = (type = LICENSE_TYPE_JWT, formData, page = 1, pageSize = 20) => async (
  dispatch,
  getState
) => {
  dispatch(createLicenseRequest());

  const token = getState().user.accessToken;

  let res;

  try {
    switch (type) {
      case 'gst': {
        res = await licenseService.createLicenseGST(token, formData);
        break;
      }
      case 'string': {
        res = await licenseService.createLicensePlatform(token, formData);
        break;
      }
      default: {
        res = await licenseService.createLicenseJWT(token, formData);
      }
    }

    if (typeof res === 'object') {
      if (res.status === 200 || res.status === 202) {
        res = await licenseService.getLicenses(token, page, pageSize);
        dispatch(
          createLicenseSuccess({
            requests: res.data.Result.requests,
            total: res.data.Result.total,
            page,
            pageSize
          })
        );
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          createLicenseFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(createLicenseFailure(e));
  }

  return res;
};

// approve license
const approveLicenseRequest = () => ({
  type: license.APPROVE_LICENSE_REQUEST
});

const approveLicenseSuccess = licenses => ({
  type: license.APPROVE_LICENSE_SUCCESS,
  licenses
});

const approveLicenseFailure = error => ({
  type: license.APPROVE_LICENSE_FAILED,
  error
});

export const approveLicenseStatusReset = () => ({
  type: license.APPROVE_LICENSE_STATUS_RESET
});

export const approveLicense = (formData, page = 1, pageSize = 20) => async (dispatch, getState) => {
  dispatch(approveLicenseRequest());

  const token = getState().user.accessToken;

  let res;

  try {
    res = await licenseService.approveLicenseRequest(token, formData);

    if (typeof res === 'object') {
      if (res.status === 200) {
        res = await licenseService.getLicenses(token, page, pageSize);
        dispatch(
          approveLicenseSuccess({
            requests: res.data.Result.requests,
            total: res.data.Result.total,
            page,
            pageSize
          })
        );
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          approveLicenseFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(approveLicenseFailure(e));
  }

  return res;
};

// reject license
const rejectLicenseRequest = () => ({
  type: license.REJECT_LICENSE_REQUEST
});

const rejectLicenseSuccess = licenses => ({
  type: license.REJECT_LICENSE_SUCCESS,
  licenses
});

const rejectLicenseFailure = error => ({
  type: license.REJECT_LICENSE_FAILED,
  error
});

export const rejectLicenseStatusReset = () => ({
  type: license.REJECT_LICENSE_STATUS_RESET
});

export const rejectLicense = (formData, page = 1, pageSize = 20) => async (dispatch, getState) => {
  dispatch(rejectLicenseRequest());

  const token = getState().user.accessToken;

  let res;

  try {
    res = await licenseService.rejectLicenseRequest(token, formData);

    if (typeof res === 'object') {
      if (res.status === 200) {
        res = await licenseService.getLicenses(token, page, pageSize);
        dispatch(
          rejectLicenseSuccess({
            requests: res.data.Result.requests,
            total: res.data.Result.total,
            page,
            pageSize
          })
        );
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          rejectLicenseFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(rejectLicenseFailure(e));
  }

  return res;
};

// upload seed file
const uploadSeedRequest = () => ({
  type: license.UPLOAD_SEED_REQUEST
});

const uploadSeedSuccess = signature => ({
  type: license.UPLOAD_SEED_SUCCESS,
  signature
});

const uploadSeedFailure = error => ({
  type: license.UPLOAD_SEED_FAILED,
  error
});

export const uploadSeedStatusReset = () => ({
  type: license.UPLOAD_SEED_STATUS_RESET
});

export const uploadSeed = seedFile => async (dispatch, getState) => {
  dispatch(uploadSeedRequest());

  const token = getState().user.profile.token;

  let res;

  try {
    res = await licenseService.uploadSeed(token, seedFile);

    if (typeof res === 'object') {
      if (res.status === 200) {
        dispatch(uploadSeedSuccess(res.data.Result));
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          uploadSeedFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(uploadSeedFailure(e));
  }

  return res;
};

// fetch contract file
const fetchContractRequest = () => ({
  type: license.FETCH_CONTRACT_REQUEST
});

const fetchContractSuccess = () => ({
  type: license.FETCH_CONTRACT_SUCCESS
});

const fetchContractFailure = error => ({
  type: license.FETCH_CONTRACT_FAILED,
  error
});

export const fetchContractStatusReset = () => ({
  type: license.FETCH_CONTRACT_STATUS_RESET
});

export const getContractFile = contractId => async (dispatch, getState) => {
  dispatch(fetchContractRequest());

  const token = getState().user.profile.token;

  let res;

  try {
    res = await licenseService.getContractFile(token, contractId);

    if (typeof res === 'object') {
      if (res.status === 200) {
        dispatch(fetchContractSuccess());
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          fetchContractFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(fetchContractFailure(e));
  }

  return res;
};

// upload contract file
const uploadContractRequest = () => ({
  type: license.UPLOAD_CONTRACT_REQUEST
});

const uploadContractSuccess = contractID => ({
  type: license.UPLOAD_CONTRACT_SUCCESS,
  contractID
});

const uploadContractFailure = error => ({
  type: license.UPLOAD_CONTRACT_FAILED,
  error
});

export const uploadContractStatusReset = () => ({
  type: license.UPLOAD_CONTRACT_STATUS_RESET
});

export const uploadContract = seedFile => async (dispatch, getState) => {
  dispatch(uploadContractRequest());

  const token = getState().user.profile.token;

  let res;

  try {
    res = await licenseService.uploadContract(token, seedFile);

    if (typeof res === 'object') {
      if (res.status === 200) {
        dispatch(uploadContractSuccess(res.data.Result));
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          uploadContractFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(uploadContractFailure(e));
  }

  return res;
};
